/* eslint-disable import/no-named-default */
import React from 'react';
import { Route } from 'react-router';

import TopicList from '../containers/TopicList';
import HomePage from '../components/HomePage';
import ArticlePanel from '../containers/ArticlePanel';
import ArticleListByTopic from '../containers/ArticleListByTopic';
import SearchFilterForm from '../containers/SearchFilterForm';
import SearchResult from '../containers/SearchResult';
import IcfArticlesContainer from '../containers/IcfArticlesContainer';
import IcfTopicContainer from '../containers/IcfTopicContainer';
import UrlResources from '../constants/UrlResources';
import BrexitComplaintsContainer from '../containers/BrexitComplaintsContainer';
import { default as HomePageV2 } from '../../../jsV2/home/containers/pages/HomePage';
import { isNewHomeExpEnabled } from '../../../jsV2/helpers/twHelper';
import {
  isShowOnlySearchLayoutEnabled,
  isBotExperienceEnabled,
  isHomeExpTransactionLayoutEnabled,
} from '../../../experimentations/helper';
import SearchOnlyHomePage from '../../../experimentations/pages/SearchOnlyHomePage';
import TXNHomePage from '../../../experimentations/pages/TXNHomePage';

const routes = [
  {
    path: '/home',
    exact: true,
    sideBar: () => <TopicList />,
    mainContainer: () => {
      if (isShowOnlySearchLayoutEnabled() || isBotExperienceEnabled()) {
        return <SearchOnlyHomePage />;
      }
      if (isHomeExpTransactionLayoutEnabled()) {
        return <TXNHomePage />;
      }
      if (isNewHomeExpEnabled()) {
        return <HomePageV2 />;
      }
      return <HomePage />;
    },
  },
  {
    path: '/homeV2',
    exact: true,
    mainContainer: () => <HomePageV2 />,
  },
  {
    path: '/topic/:topicId',
    exact: true,
    sideBar: () => <TopicList />,
    mainContainer: () => <ArticleListByTopic />,
  },
  {
    path: '/topic/:topicId/:subTopicId',
    exact: true,
    sideBar: () => <TopicList />,
    mainContainer: () => <ArticleListByTopic />,
  },
  {
    path: '/article/:articleId',
    exact: true,
    sideBar: () => <TopicList />,
    mainContainer: () => <ArticlePanel />,
  },
  {
    path: '/search',
    exact: true,
    sideBar: () => <SearchFilterForm />,
    mainContainer: () => <SearchResult />,
  },
  {
    path: `/${UrlResources.PAYPALGUIDE}`,
    exact: true,
    mainContainer: () => <IcfTopicContainer />,
  },
  {
    path: `/${UrlResources.PAYPALGUIDE}/:icfId`,
    exact: true,
    mainContainer: () => <IcfArticlesContainer />,
  },
  {
    path: `/${UrlResources.COMPLAINTS}`,
    exact: true,
    mainContainer: () => <BrexitComplaintsContainer />,
  },
];

const SideBar = function () {
  return (
    <div>
      {routes.map((route) => (
        <Route key={route.path} path={route.path} exact={route.exact} component={route.sideBar} />
      ))}
    </div>
  );
};

const MainContainer = function () {
  return (
    <div>
      {routes.map((route) => (
        <Route key={route.path} path={route.path} exact={route.exact} component={route.mainContainer} />
      ))}
    </div>
  );
};

export default {
  sideBar: <SideBar />,
  mainContainer: <MainContainer />,
};
